module.exports = __webpack_public_path__ + "img/bingo_ball-28.78e3fad7.png";